export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.7.16-1436.18",
  commitId: "0ead9d6931e87fe4f91a2682f7e4ed6c7ad2ca17",
  commitTime: "2026-07-16T14:36:18.000Z",
});
